// Logo path: place furniflex-logo.png (or .svg) in public/assets/
const PUBLIC_URL = process.env.PUBLIC_URL || '';
export const LOGO_URL = `${PUBLIC_URL}/assets/furniflex-logo.png`;
